import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import React, { Component } from "react";
import config from "../config";
import moment from 'moment/moment'
import 'moment-timezone';

const styles = (theme) => ({
  root: {
    display: "flex",
  },
});
class ContestListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
    };
  }
  componentDidMount() {
    return fetch(config.backend_url + "contests").then((response) => {
      response.json().then((json) => {
        this.setState({ results: json, loading: false });
      });
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state.loading) {
      return <p>Loading...</p>;
    }
    return (
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>最新コンテスト</TableCell>
              <TableCell align="left">開始時間</TableCell>
              <TableCell align="left">終了時間</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.results.map((contest) => {
              var begin = moment(contest.start_at * 1000).tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm");
              var end = moment(contest.end_at * 1000).tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm");
              return (
                <TableRow key={contest.name}>
                  <TableCell component="th" scope="row">
                    <a href={"contests/" + contest.id + "/"}>
                      {" "}
                      {contest.name}{" "}
                    </a>
                  </TableCell>
                  <TableCell align="left">
                    {begin.toLocaleString()}
                  </TableCell>
                  <TableCell align="left">
                    {end.toLocaleString()}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

ContestListView.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default withStyles(styles)(ContestListView);
